module.exports = __webpack_public_path__ + "img/editList.799176ac.svg";